import { Modal, Form } from "react-bootstrap";
import { useState } from 'react';
import { useNotification } from '../../contexts/NotificationContext';
import { authFetch } from '../../utils/authFetch';
import { useUserAPI } from '../../contexts/UserAPIContext';
import Footer from '../../components/Footer';

const Exportacoes = () => {
  const [showModalExportar, setShowModalExportar] = useState(false);
  const { userAPIData } = useUserAPI();
  const { showNotification } = useNotification();
  const [anoRef, setAnoRef] = useState(new Date().getFullYear());
  const [mesRef, setMesRef] = useState(new Date().getMonth() + 1);
  const [tipoExport, setTipoExport] = useState(null);
  const [tipoExportNome, setTipoExportNome] = useState('');
  const [exportacaoAnual, setExportacaoAnual] = useState(false);

  const exportButtons = [
    { id: 1, nome: 'Sessões por Plano', icon: 'bi bi-file-earmark-spreadsheet' },
    { id: 2, nome: 'Sessões por Terapeuta', icon: 'bi bi-person-workspace' },
    { id: 3, nome: 'Sessões por Paciente', icon: 'bi bi-people' },
    { id: 4, nome: 'Sessões por Turno', icon: 'bi bi-clock-history' },
    { id: 5, nome: 'Atendimentos Mensal', icon: 'bi bi-cash-coin' }
  ];

  const abrirModalSessoesExp = (tipo, nome) => {
    setTipoExport(tipo);
    setTipoExportNome(nome);
    setExportacaoAnual(false);
    setShowModalExportar(true);
  }

  const exportarDados = async (e) => {
    e.preventDefault();

    try {
      let url = "";
      let nomeArquivo = "";

      // Se for exportação anual, não incluir o parâmetro month
      const monthParam = exportacaoAnual ? '' : `month=${mesRef}&`;
      const monthSuffix = exportacaoAnual ? '' : `_${mesRef}`;

      switch (tipoExport) {
        case 1:
          url = `report/plan-appointments?${monthParam}year=${anoRef}`;
          nomeArquivo = `sessoes_por_plano${monthSuffix}_${anoRef}`
          break;
        case 2:
          url = `report/therapist-appointments?${monthParam}year=${anoRef}`;
          nomeArquivo = `sessoes_por_terapeuta${monthSuffix}_${anoRef}`
          break;
        case 3:
          url = `report/patient-appointments?${monthParam}year=${anoRef}`;
          nomeArquivo = `sessoes_por_paciente${monthSuffix}_${anoRef}`
          break;
        case 4:
          url = `report/period-appointments?${monthParam}year=${anoRef}`;
          nomeArquivo = `sessoes_por_turno${monthSuffix}_${anoRef}`
          break;
        case 5:
          url = `report/patient-payment?${monthParam}year=${anoRef}`;
          nomeArquivo = `controles_fechados${monthSuffix}_${anoRef}`
          break;
        default:
          showNotification("danger", "Tipo de relatório inválido.");
          return;
      }

      const response = await authFetch(url, {
        method: "GET",
        headers: {
          Accept: "text/csv",
        },
      });

      if (!response.ok) {
        throw new Error("Erro ao exportar dados.");
      }

      const blob = await response.blob();
      const urlBlob = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = urlBlob;
      link.download = nomeArquivo;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(urlBlob);

      showNotification("success", "Exportação concluída com sucesso!");
      setShowModalExportar(false);
    } catch (error) {
      console.error(error);
      showNotification("error", "Erro ao exportar dados.");
    }
  };

  return (
    <div className="content">
      <div className="card">
        <div className="card-body p-3">
          <h3 className="font-weight-bolder mb-4">Exportações</h3>

          {(userAPIData.userRoleId === 1 || userAPIData.userRoleId === 5) && (
            <div className="row g-3">
              {exportButtons
                .filter(button => {
                  // Se role 5, mostrar apenas o relatório de Atendimentos Mensal (id: 5)
                  if (userAPIData.userRoleId === 5) {
                    return button.id === 5;
                  }
                  // Se role 1, mostrar todos os relatórios
                  return true;
                })
                .map((button) => (
                <div key={button.id} className="col-md-4">
                  <div className="card h-100 shadow-sm">
                    <div className="card-body d-flex flex-column align-items-center justify-content-center p-4">
                      <i className={`${button.icon} text-primary mb-3`} style={{ fontSize: '2rem' }}></i>
                      <h6 className="text-center mb-3">{button.nome}</h6>
                      <button
                        className="btn btn-info btn-sm w-100"
                        onClick={() => abrirModalSessoesExp(button.id, button.nome)}
                      >
                        Exportar <i className="bi bi-download ms-1"></i>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <Modal 
        show={showModalExportar} 
        onHide={() => setShowModalExportar(false)} 
        centered
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="bi bi-file-earmark-excel me-2"></i>
              Exportar {tipoExportNome}
            </h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={() => setShowModalExportar(false)}
            />
          </div>
          <Form onSubmit={exportarDados}>
            <div className="modal-body">
              <div className="container">
                <div className="row g-3">
                  <div className="col-12">
                    <div className="form-check">
                      <input 
                        className="form-check-input" 
                        type="checkbox" 
                        id="exportacaoAnual"
                        checked={exportacaoAnual}
                        onChange={(e) => setExportacaoAnual(e.target.checked)}
                      />
                      <label className="form-check-label" htmlFor="exportacaoAnual">
                        Exportação anual (sem mês específico)
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Ano</label>
                    <input 
                      type="number" 
                      className="form-control form-control-sm" 
                      min="2000"
                      max="2099"
                      required 
                      value={anoRef} 
                      onChange={(e) => setAnoRef(e.target.value)} 
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Mês {exportacaoAnual && <span className="text-muted">(opcional)</span>}</label>
                    <select 
                      className="form-select form-select-sm" 
                      value={mesRef} 
                      onChange={(e) => setMesRef(e.target.value)}
                      disabled={exportacaoAnual}
                    >
                      {[...Array(12)].map((_, i) => (
                        <option key={i + 1} value={i + 1}>
                          {new Date(2000, i).toLocaleString('pt-BR', { month: 'long' })}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button 
                type="button" 
                className="btn btn-secondary btn-sm" 
                onClick={() => setShowModalExportar(false)}
              >
                Cancelar
              </button>
              <button type="submit" className="btn btn-info btn-sm">
                <i className="bi bi-download me-1"></i>
                Exportar
              </button>
            </div>
          </Form>
        </div>
      </Modal>
      <Footer />
    </div>
  )
}

export default Exportacoes